module.exports = __webpack_public_path__ + "media/application/images/ui/icon-facebook-af0e99552953f333dbae7982331298ab.png";